var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1518 11.3199L12.1361 20.3355C10.0859 22.3857 6.76177 22.3857 4.71152 20.3355C2.66126 18.2852 2.66127 14.9611 4.71152 12.9109L13.7271 3.89524C15.094 2.52841 17.31 2.52841 18.6769 3.89524C20.0437 5.26208 20.0437 7.47816 18.6769 8.84499L10.0148 17.507C9.3314 18.1905 8.22336 18.1905 7.53994 17.507C6.85653 16.8236 6.85653 15.7156 7.53994 15.0322L15.1413 7.43078",
    stroke: "#2948A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.a35530598c4fd2e9cd02f10dc9b7c27a.svg";
export { ForwardRef as ReactComponent };